export default __webpack_public_path__ + "error-icon.svg";